import React, { useEffect } from "react";

import "./fmdo.scss";
import ApplicationModal from "./ApplicationModal";
import { loadMetaPixel } from "./pixel";

// Shareable form-only link (/b2b): shows ONLY the application form on a dark
// page — collect details + email the B2B letter, no payment step.
export default function B2BPage() {
  useEffect(() => {
    document.body.classList.add("fmdo-body");
    document.documentElement.classList.add("fmdo-html");
    document.title = "FM Digital Official — B2B Application";
    loadMetaPixel();
    return () => {
      document.body.classList.remove("fmdo-body");
      document.documentElement.classList.remove("fmdo-html");
    };
  }, []);

  return <ApplicationModal formOnly standalone />;
}
